import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_APP_KEY || "AIzaSyAEqb1levawkGMLfjXvbjGz9n3VTzyXvYo",
  authDomain: import.meta.env.VITE_FB_AUTH_DOMAIN || "dev--lystloc.firebaseapp.com",
  databaseURL: import.meta.env.VITE_FB_DATABASE_URL || "https://dev--lystloc-default-rtdb.firebaseio.com",
  projectId: import.meta.env.VITE_FB_PROJECT_ID || "dev--lystloc",
  storageBucket: import.meta.env.VITE_FB_STORAGE_BUCKET || "dev--lystloc.appspot.com",
  messagingSenderId: import.meta.env.VITE_FB_MESSAGE_SENDER_ID || "30453587288",
  appId: import.meta.env.VITE_FB_APP_ID || "1:30453587288:web:e1c4af78c8040a1063192d",
  measurementId: import.meta.env.VITE_FB_MEASUREMENT_ID || "G-TR6QE1937J",
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
